import { assistantChartDataId } from "@inrev/common";
import * as z from "zod";

/**
 * The corporate structure `ask_org_chart` read, stored under the conversation by apps/api and
 * drawn by the panel. The tool returns the whole block, so the agent pastes it rather than
 * writing it; the panel fetches the structure, so no entity in it is one the model typed.
 */
export const orgChartSchema = z.strictObject({
	source: z.literal("orgchart"),
	chartId: assistantChartDataId,
	title: z.string().optional(),
});

export type OrgChart = z.infer<typeof orgChartSchema>;
